// Socket.IO event names used by the generic websocket layer.
// Clients emit subscribe/unsubscribe to manage topic membership; the server
// emits `message` to push payloads to subscribers of a given topic.
export const WS_EVENT_MESSAGE = 'message'
export const WS_EVENT_SUBSCRIBE = 'subscribe'
export const WS_EVENT_UNSUBSCRIBE = 'unsubscribe'

export type WsSubscribeRequest = {
  topic: string
}

export type WsSubscribeAck = { ok: true } | { ok: false; error: string }

// Generic envelope for every server → client message. `type` lets handlers
// dispatch on payload shape; `topic` lets the client confirm which channel
// the message arrived on.
//
// Feature-specific message types live next to their feature, not here —
// the generic layer is type-agnostic about payload shapes.
export type WsMessage<TType extends string = string, TPayload = unknown> = {
  topic: string
  type: TType
  payload: TPayload
}
